import React from 'react';
import moment from 'moment';
import { useUserInfo } from '../../../../hooks';

function LearningInfo() {
  const { info } = useUserInfo();
  
  return (
    <form className="w672 w672_tb border">
      <h2>학습자 정보</h2>
      {
        (info?.learner) && (
          info.learner.map((item, index) => (
            <article key={index} className="mem_info cls">
              <div className="part1">
                <div>{item.name}</div>
              </div>
              <div className="part2">
                <div>
                  {moment(item.birth).format('YYYY. MM')}
                </div>
              </div>
              {/* <div className="part3">
                <div>
                  휴회<span className="hide_m">회원</span>
                </div>
              </div> */}
            </article>
          ))
        )
      }
    </form>
  );
}

export default LearningInfo;